define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi",
	"csi/_base/underscore",
	"csi/action/Switchboard",
	"csi/comm/PostRequest",
	"csi/config",
	"csi/def/Action",
	"csi/view/ToolbarPluginSwitchboard",
	"csi/xml",
	"csi/xml/Query",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"SiteAdmin/DataSheetTablePreferences",
	"../SizeChart",
	"./_SizeChartTableMixin",
	"./SizeChartDimension2SizesSwitchboard",
	"./Table"
], function(declare,lang,domClass,csi,_,SwitchboardAction,PostRequest,config,Action,ToolbarPluginSwitchboard,xml,Query,
			{SizeChartDimensionFormatType},DataSheetTablePreferences,SizeChart,_SizeChartTableMixin,SizeChartDimension2SizesSwitchboard,Table) {

	// Path to ShapeSizeChart's Dimensions
	var PATH_SHAPE_SC_DIM = "Child:__Parent__/Child:ShapeSizeChart/Child:CurrentRevision/Child:Items";
	var SHAPE = "Shape";
	var INCREMENT = "Increment";
	var NONE = "None";
	var ABSOLUTE = "Absolute";
	var RELATIVE = "Relative";
	var DELTA = 0.00005;

	var	_Preferences = declare(DataSheetTablePreferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDimensionFormat", SizeChartDimensionFormatType.DEFAULT, false, "SizeChartDimensionFormat");
			this.addCustomOption("sizeChartDisplay", SizeChart.gradingDefaultDisplay, false, "SizeChartDisplay");
			this.addCustomOption("sizeChartCompare", SizeChart.compareDefault, false);
			this.addCustomOption("sizeChartPrintBaseSize", false, false, "SizeChartPrintBaseSize");
			this.addCustomOption("sizeChartDisplayAllSizes", false, false, "SizeChartDisplayAllSizes");
			this.addCustomOption("sizeChartHighlightBlank", true, false, "SizeChartHighlightBlank");
		}
	});

	var _Switchboard = declare(ToolbarPluginSwitchboard, {
		bDelayInitialization: true,
		disableButtonAction: true,
		idViewProperty: "urlSubSizeRange",
		refreshStoreOptions: true,
		resDefault: "SelectAll",
		switchboardPath: "Child:SizeChartSubSizeRanges",

		canShowPlugin: function() {
			// summary: return true if there are more than 1 sub size range. Noted that this.store.query() also returns dummy for "All"
			return this.store && this.store.isLoaded() && (this.store.query().length > 2);
		},

		onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
			// summary: do nothing - idViewProperty handles it all
		},

		validatePlugin: function(/*Context*/ctx) {
			// summary: hide if printing
			return !ctx.bPrint;
		}
	});

	return declare([Table,_SizeChartTableMixin], {
		prefClass: _Preferences,

		// Boolean: indicates if table showing base size vs. all sizes
		sizeChartPrintBaseSize: false,

		// Boolean: indicates if table showing original increment values
		//bCompareIncrements: false,

		// Boolean: indicates if table showing shape size chart increment values
		bCompareShape: false,

		// Boolean: hide old review comments if not on current revision
		bHideOldComments: false,

		// Response: result from call to get original increment values
		//_compareIncrements: null,

		// Shape SizeChart Increments values stored as a map {SysID, [Increments], Tolerance, ToleranceNegative}
		//_fromShapeDimensions: null,

		// String: selected sub size range
		urlSubSizeRange: csi.EMPTY_URL,

		// Boolean: indicates if table showing single sub-size range
		_bFixedSubSizeRange: false,

		// Boolean: indicates if table showing revised values (from review) vs. original values
		_bReviewValues: false,

		// Object: map of SizeChartDimension URL to object mapping index to increment value
		//_incrementDifferences: null,

		// String: last size range value
		_urlSizeRange: null,

		// String: last value of compare, for example Shape, Increment, None
		_previousSizeChartCompare: null,

		getBaseSizes: function() {
			// summary: return all base sizes in view
			var	ssr = this.getSelectedSubSizeRange();
			if (ssr) {
				return this.cacheView.getNodes([ssr.BaseSize]);
			}

			return this.cacheView.getPathNodes(this.getViewNode(), "Child:SizeChartSubSizeRanges/Child:BaseSize");
		},

		getComparableIncrements: function(/*Node*/dim) {
			// summary: return dimension for comparison
			return this._compareIncrements && this._compareIncrements[dim.Actual] ||
				this._fromShapeDimensions && this._fromShapeDimensions[dim.ShapeSysID] && this._fromShapeDimensions[dim.ShapeSysID].Increments;
		},

		getDimensionDifference: function(/*String*/url, /*Number?*/index) {
			// summary: return increment value if different from current value
			var	obj = this._incrementDifferences;
			var	diffs = obj && obj[url];
			return (diffs && (index != null)) ? diffs[index] : diffs;
		},

		/**
		 * Return Tolerance value if different from current value
		 * @param {string} url - SCDim URL
		 * @param (string} id - attribute id
		 */
		getToleranceDifference: function(url, id) {
			var obj;
			var idx;
			var dim = this.cacheView.getNode(url);
			if (this.bCompareIncrements){
				idx = dim.$URL;

				// if we had just done a Copy, _compareTolerances for our idx might not be there yet.
				if (!this._compareTolerances[idx]) {
					this._buildToleranceDifference(dim);
				}

				obj = this._compareTolerances;

			} else {
				obj = this._fromShapeDimensions;
				idx = dim.ShapeSysID;
			}
			var diffs = obj && obj[idx];
			return (diffs && (id != null)) ? diffs[id] : diffs;
		},

		getPrintProperties: function() {
			// summary: return object containing properties from view necessary to recreate it for printing that are not custom view options
			var params = this.inherited(arguments);
			params.urlSubSizeRange = this.urlSubSizeRange;
			params.selectedDim2Sizes = this.selectedDim2Sizes;
			return params;
		},

		getDim1Sizes: function() {
			// summary: return sizes in view
			var ssr = this.getSelectedSubSizeRange();

			if (ssr) { // if sub size range selected
				return this.cacheView.getNodes(ssr.Sizes)
			} else if (this.getViewNode().SizeChartSubSizeRanges.length == 0) { // if no size range
				return [];
			} else if (this.cacheView.getNode(this.getViewNode().SizeChartSubSizeRanges[0]).IsTwoDim) { // if 2D
				return this.getViewNode().SizeChartDimension1Sizes;
			} else { // otherwise get all the sizes from the active sub ranges.  2D size ranges can't be composite
				let activeSizes = [];
				this.getSubSizeRanges().forEach(function(sr) {
					activeSizes = activeSizes.concat(sr.Sizes);
				});
				return activeSizes;
			}
		},

		getSelectedSubSizeRange: function() {
			// summary: return switchboard's selected sub size range
			return this.cacheView.getNode(this.urlSubSizeRange);
		},

		getSubSizeRanges: function() {
			// summary: return object containing metadata about sub size ranges
			return this.cacheView.getNodes(this.getViewNode().SizeChartSubSizeRanges).filter(r => r.Active);
		},

		/**
		 * Enable tooltip "Restore from Increment" when "Compare Increments"
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionRestoreDimensionFromIncrement: function(ctx, action) {
			// C8-9087 : Enable "Restore from Increment" when CV option "Compare Increments" is on
			if (!this.bCompareIncrements) {
				return false;
			}

			// C8-9291 C8-9290 : Handles tooltip actions for LockShapeDimensionValues type
			var dimensionNode = ctx.getNode();
			var scRevNode = ctx.getParent();
			var scNode = (scRevNode != null) ? ctx.cache.getNode(scRevNode.__Parent__) : null;
			var lockShapeDimensionValues = config.getNodeSetting(scNode, "LockShapeDimensionValues");
			return (dimensionNode != null && dimensionNode.ShapeSysID == "") || (!lockShapeDimensionValues);
		},

		/**
		 * Enable "Restore from Shape" when "Compare Shape" is on
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionRestoreDimensionFromShape: function(ctx, action) {
			return this.bCompareShape && ctx.getNode().ShapeSysID;
		},

		onActionResetPatterns: function(/*Controller*/ac, /*CallMethod?*/call) {
			// summary: add SizeChartSubSizeRange URL as parameter to the reset patterns request
			if (xml.isValidURL(this.urlSubSizeRange))
				call.addParameter("SizeChartSubSizeRangeURL", xml.ATTR_REF, this.urlSubSizeRange);
		},

		onActionRestoreIncrements: function(/*Controller*/ac, /*CallMethod?*/call) {
			// summary: add SizeChartSubSizeRange URL as parameter to the reset patterns request
			if (xml.isValidURL(this.urlSubSizeRange))
				call.addParameter("SizeChartSubSizeRangeURL", xml.ATTR_REF, this.urlSubSizeRange);
		},

		onActionRestoreDimensionIncrementAtIndex: function(/*Controller*/ac, /*CallMethod?*/call) {
			// summary: restore increment at given index and reset the corresponding SizeChartSubSizeRange.IncrementsChanged flag if applicable
			var	v = this.getDimensionDifference(ac.m_urlNode, ac.keyContainer);
			call.addParameter("Value", xml.ATTR_DOUBLE, v);

			if (ac.ren.isAbsoluteDisplay(ac._ctx))
				call.addParameter("ViewDisplayMode", xml.ATTR_STRING, ABSOLUTE);
			else if (ac.ren.isRelativeDisplay(ac._ctx))
				call.addParameter("ViewDisplayMode", xml.ATTR_STRING, RELATIVE);
		},

		onActionRestoreDimensionIncrements: function(/*Controller*/ac, /*CallMethod?*/call) {
			// summary: restore increments for given dimension
			// If a particular SizeChartSubSizeRange is selected on the switchboard, only values of that sub range will be restored
			if (xml.isValidURL(this.urlSubSizeRange))
				call.addParameter("SizeChartSubSizeRangeURL", xml.ATTR_REF, this.urlSubSizeRange);
		},

		/**
		 * Update call parameters for operation SizeChartRestoreDimensionTolerances
		 * @param {Controller} ac
		 * @param {CallMethod} call
		 * @param {string} sign
		 */
		_setToleranceSign: function(ac, call, sign){
			call.removeParameter("ParentURL");
			call.addParameter("ParentURL", xml.ATTR_REF, ac.getNodeURL());
			call.addParameter("Sign", xml.ATTR_STRING, sign);
		},

		/**
		 * Set call parameters for Positive Tolerance Restore action
		 * @param {Controller} ac
		 * @param {CallMethod} call
		 */
		onActionRestoreTolerancePositive: function(ac, call) {
			this._setToleranceSign(ac, call, "Positive");
		},

		/**
		 * Set call parameters for Negative Tolerance Restore action
		 * @param {Controller} ac
		 * @param {CallMethod} call
		 */
		onActionRestoreToleranceNegative: function(ac, call) {
			this._setToleranceSign(ac, call, "Negative");
		},

		/**
		 * Set call parameters for Both Tolerances Restore action
		 * @param {Controller} ac
		 * @param {CallMethod} call
		 */
		onActionRestoreToleranceBoth: function(ac, call) {
			this._setToleranceSign(ac, call, "");
		},

		/**
		 * Build this._compareTolerances object to be used with Tolerance renderer to render tolerance comparison values
		 * @param {Context} ctx
		 */
		_buildToleranceDifferences: function(){
			const node = this.getViewNode();
			const items = node.Items;
			this._compareTolerances = {};

			_.each(items, function(item) {
				const itemNode = this.cacheView.getNode(item);
				this._buildToleranceDifference(itemNode);
			}, this);
		},

		_buildToleranceDifference: function(itemNode) {
			const itemOriginalPGD = this.cacheView.getNode(itemNode.OriginalPGD);
			if (itemOriginalPGD){
				this._compareTolerances[itemNode.$URL] = {
					Tolerance: itemOriginalPGD.Tolerance,
					ToleranceNegative: itemOriginalPGD.ToleranceNegative
				}
			}
		},

		onBuildDeferreds: function(/*Context*/ctx, /*Deferred[]*/dfds) {
			// Compare increment/shape based on custom view setting.
			this._compareValues();

			// summary: extension point for add deferreds necessary to render table
			if (this.bCompareIncrements) {
				var	dfd = new PostRequest("ProductSpec","SizeChartGetCopyWithIncrementLibraryValues", {
					ParentURL: ctx.getNodeURL()
				}).post();

				dfd.then(lang.hitch(this, function(response) {
					this._incrementDifferences = {};
					this._compareIncrements = csi.hashArray(response.getNodes(), "Actual", "Increments");
				}));

				dfds.push(dfd);
			}
		},

		onChangeCustomView: function() {
			// summary: reset active product colors when custom view is changed
			this.set("urlSubSizeRange", csi.EMPTY_URL);
			this.inherited(arguments);
		},

		/**
		 * @override
		 */
		onViewResults: function(qr, resultNodes) {
			this.inherited(arguments);

			if (this.bCompareIncrements) {
				this._buildToleranceDifferences();
			}
		},

		postActionToggleReviewValues: function(/*Controller*/ac) {
			// summary: toggle to display target vs. revised values
			this._bReviewValues = !ac.m_bToggle;
			this.refreshWidget();
		},

		setDimensionDifferences: function(/*Node*/scDimension, /*Number[]*/incCurrent, /*Number[]*/incNew) {
			var self = this;
			var obj;
			// summary: store differences between current increment values and new increment values
			var sizeChartRevData = this.getSizeChartRevisionData();
			var isTwoDimSizeChart = sizeChartRevData && sizeChartRevData.isTwoDim();
			var dim1BaseIndex = isTwoDimSizeChart ? sizeChartRevData.getDim1BaseIndex() : -1;
			var isDisplayTwoDim = isTwoDimSizeChart && this.displayTwoDimension(scDimension);
			var	ranges = this.getSubSizeRangeData();
			// For "Compare Increment" action, do NOT compare base size Increment; for "Compare Shape" action, DO compare base size Increment
			var compareBaseSize = this.bCompareShape;
			var absoluteDisplayMode = this.isAbsoluteDisplayMode();
			var compareBaseAbsolute = compareBaseSize && absoluteDisplayMode;

			_.each(incNew, function(n, i) {
				// For 1D size chart dimension on a 2D size chart, the base index is the base size dimension1 index
				var baseIndex = isTwoDimSizeChart && !isDisplayTwoDim ? dim1BaseIndex : ranges.getBaseIndex(i);
				// if display mode is absolute and compare shape
				// C8-9432 Absolute mode needs to display differences in absolute values
				if (compareBaseAbsolute) {
					var currentBaseValue = incCurrent[baseIndex];
					var newBaseValue = incNew[baseIndex];
					if (i === baseIndex) {
						// just see if the base values are different
						if ((Math.abs(currentBaseValue - newBaseValue) >= DELTA)) {
							obj = obj || {};
							obj[i] = n;
						}
					} else {
						// If not base, then need to compare difference between base and absolute value.
						// Do this for current and new, and the difference between the current and new should be zero.
						// Complex because each step away from base is cumulative.
						var currentBaseIncDiff;
						var newBaseIncDiff;
						if (baseIndex === 0) {
							// Handle if base is first increment, which is easier.
							// We add base to increments because values are increasing.
							currentBaseIncDiff = currentBaseValue + self._sumElements(incCurrent.slice(1, i + 1));
							newBaseIncDiff = newBaseValue + self._sumElements(incNew.slice(1, i + 1));
							if (Math.abs(currentBaseIncDiff - newBaseIncDiff) >= DELTA) {
								obj = obj || {};
								obj[i] = n;
							}
						} else if (baseIndex === incCurrent.length - 1) {
							// Handle if base is last increment, which is easier.
							// We subtract base to increments because values are decreasing.
							currentBaseIncDiff = currentBaseValue - self._sumElements(incCurrent.slice(i, -1));
							newBaseIncDiff = newBaseValue - self._sumElements(incNew.slice(i, -1));
							if (Math.abs(currentBaseIncDiff - newBaseIncDiff) >= DELTA) {
								obj = obj || {};
								obj[i] = n;
							}
						} else {
							if (i < baseIndex){
								// Handle if current index is less than base index.
								// We subtract base to increments because values are decreasing.
								currentBaseIncDiff = currentBaseValue - self._sumElements(incCurrent.slice(i, baseIndex));
								newBaseIncDiff = newBaseValue - self._sumElements(incNew.slice(i, baseIndex));
								if (Math.abs(currentBaseIncDiff - newBaseIncDiff) >= DELTA) {
									obj = obj || {};
									obj[i] = n;
								}
							} else {
								// Handle if current index is greater than base index.
								// We add base to increments because values are increasing.
								currentBaseIncDiff = currentBaseValue + self._sumElements(incCurrent.slice(baseIndex + 1, i+1));
								newBaseIncDiff = newBaseValue + self._sumElements(incNew.slice(baseIndex + 1, i+1));
								if (Math.abs(currentBaseIncDiff - newBaseIncDiff) >= DELTA) {
									obj = obj || {};
									obj[i] = n;
								}
							}
						}
					}
				} else {
					// display mode absolute AND compare shape is false
					if ((i != baseIndex || compareBaseSize) && (Math.abs(n - incCurrent[i]) >= DELTA)) {
						obj = obj || {};
						obj[i] = n;
					}
				}
			});

			var urlDim = scDimension.$URL;
			if (this._incrementDifferences) {
				if (obj) {
					this._incrementDifferences[urlDim] = obj;
				} else {
					delete this._incrementDifferences[urlDim];
				}
			}
		},

		/**
		 * Sum all elements of an array, excluding values of -999.
		 * @param {Array} elements - Array of numeric values
		 * @return {Array} - sum of elements, excluding values of -999
		 */
		_sumElements: function(elements) {
			return Math.abs(elements.reduce(
				function (total, num) {
					if (total === -999) total = 0;
					if (num === -999) num = 0;
					return total + num
				}
			));
		},

		/**
		 * @override
		 * if showing revised values, then query for review data
		 */
		onCreateMainQueryLevel: function(ql) {
			this.inherited(arguments);

			if (this._bReviewValues) {
				ql.addDependencyPaths(["Child:ReviewData"]);
			}
			if (this.bCompareIncrements) {
				ql.addDependencyPaths(["Child:OriginalPGD"]);
			}
		},

		onViewStartBuild: function() {
			// summary: if size range has changed, then refresh sub size range switchboard store
			var	scr = this.getViewNode();

			// reset cached size range data after each query for data
			this.resetSubSizeRangeData();
			this.resetSizeChartRevisionData();

			if (scr.SizeRange != this._urlSizeRange) {
				this._urlSizeRange = scr.SizeRange;
				// this.set("urlSubSizeRange", csi.EMPTY_URL);
				this.toolbarNode.getPlugin("SelectSizeChartSubSizeRange").refreshStore(csi.EMPTY_URL);
			}
		},

		/**
		 * Store the shape size chart increments values on map this._fromShapeDimensions {SysID, {[Increments], Tolerance, ToleranceNegative}}
		 */
		_processShapeIncrements: function() {
			var scRev = this.getViewNode();
			if (!scRev) {
				return;
			}

			var shapeSCDims = this.cacheView.getPathNodes(scRev, PATH_SHAPE_SC_DIM);
			if (_.isEmpty(shapeSCDims)) {
				return;
			}

			this._incrementDifferences = {};

			var obj = {};
			var iDim = 0;
			var n = _.size(shapeSCDims);
			for (iDim = 0; iDim < n; ++iDim) {
				var scDim = shapeSCDims[iDim];
				var obj2 = {
					Increments: scDim.Increments,
					Tolerance: scDim.Tolerance,
					ToleranceNegative: scDim.ToleranceNegative
				};
				obj[scDim.SysID] = obj2;
			}
			this._fromShapeDimensions = obj;
		},

		_resolveView: function() {
			// summary: update view configuration based on context
			var tb = this.defView.defToolbar;
			var scr = this.getViewNode();

			if (scr) {
				this._urlSizeRange = scr.SizeRange;
				this._bFixedSubSizeRange = xml.isValidURL(this.urlSubSizeRange);

				// add switchboard for sub size ranges if size range is not fixed (i.e. for printing)
				if (!this._bFixedSubSizeRange) {
					tb.addAction(lang.mixin(new Action(), {m_id: "|"}), 0);
					tb.addAction(lang.mixin(new SwitchboardAction(), {
						classToolbarPlugin: _Switchboard,
						m_id: "SelectSizeChartSubSizeRange",
						m_fixedQuery: new Query().Attr("Active", xml.OP_EQUALS, true)
					}), 0);
				}

				if (scr.Review != csi.EMPTY_URL) {
					// mark as read-only if in review mode
					this.defView.bReadOnly = true;
					this.bHideOldComments = !scr.IsCurrent;

					// dependency path needed to support ToggleReviewValues action
					this.defView.m_depPaths = this.defView.m_depPaths || [];
					this.defView.m_depPaths.push("Child:Review/Child:ReviewSizes");

					tb.removeAction("PasteSizeChart");
				} else {
					tb.removeAction("ToggleReviewValues");
				}

				// Proceed only if SizeChart is linked to Shape and is not in Review
				var sizeChart = this.cacheView.getNode(scr.__Parent__);
				if (sizeChart && xml.isValidURL(sizeChart.ShapeSizeChart) && !xml.isValidURL(scr.Review)) {
					this.defView.m_depPaths = this.defView.m_depPaths || [];
					this.defView.m_depPaths.push(PATH_SHAPE_SC_DIM);
				}
			}

			// TA32077: if Increment is on 2-d, add a Multi-select dropdown so that users can filter out the 2nd dimension(s) as desired
			tb.addAction(lang.mixin(new Action(), {m_id: "|"}), 0);
			tb.addAction(lang.mixin(new SwitchboardAction(), {
				classToolbarPlugin: SizeChartDimension2SizesSwitchboard,
				m_id: "SelectSizeChartDimension2Sizes"
			}), 0);

			// C8-533: Hide divider for the "Copy to Multiple" action pop up dialog
			if (this.hideDividers) {
				this.relRoot.dividerType = null;
			}

			this.inherited(arguments);
		},

		isAbsoluteDisplayMode: function() {
			return xml.enumGetText(this.sizeChartDisplay) === ABSOLUTE;
		},

		_isTwoDim: function() {
			// return boolean true if the parent Increment has two dimensional sizes
			var node = this.getViewNode();
			var dimension2Sizes = node && node.SizeChartDimension2Sizes;
			return !_.isEmpty(dimension2Sizes);
		},

		/**
		 * Compare original and current dimension increment or shape
		 * values depending on custom view property value
		 */
		_compareValues: function() {
			var scr = this.getViewNode();
			var sizeChart = this.cacheView.getNode(scr.__Parent__);
			var currentCompareValue = xml.enumGetText(this.sizeChartCompare);
			var product = this.cacheView.getNode(sizeChart.__Parent__);
			var type = product ? product.$Type : null;

			delete this._incrementDifferences;

			// Check compare custom view property.
			if (currentCompareValue === INCREMENT) {
				// We do not support showing increment values when review is empty or
				// when using Percentage format for tolerances (which is rarely used)
				if (scr.Review === csi.EMPTY_URL && !SizeChart.bPct) {
					// compare increment
					this._previousSizeChartCompare = INCREMENT;
					this.bCompareShape = false;
					delete this._compareIncrements;
					delete this._compareTolerances;
				}
			} else if (type && type !== SHAPE && currentCompareValue === SHAPE) {
				// Only allow compare shape if we are on a Style SizeChart,
				// and the SizeChart is linked to Shape and is not in review
				if (xml.isValidURL(sizeChart.ShapeSizeChart) && !xml.isValidURL(scr.Review)) {
					// compare shape
					this._previousSizeChartCompare = SHAPE;
					this.bCompareShape = true;
					delete this._compareIncrements;
					delete this._compareTolerances;

					if(this.bCompareShape)
						this._processShapeIncrements();
				}
			} else {
				// Custom view property was None.
				if (this._previousSizeChartCompare === INCREMENT) {
					delete this._compareIncrements;
					delete this._compareTolerances;
				} else if (this._previousSizeChartCompare === SHAPE) {
					this.bCompareShape = false;
				}
				this._previousSizeChartCompare = NONE;
			}
			domClass.toggle(this.domNode, "tableSizeChartCompare", this.bCompareIncrements || this.bCompareShape);
		},

		/**
		 * @override
		 * set this.bCompareIncrement flag prior to _createQueryLevel and comparison drawings
		 */
		onViewPreferences: function() {
			this.bCompareIncrements = xml.enumGetText(this.sizeChartCompare) == INCREMENT;

			this.inherited(arguments);
		}

	});
});
